import styled from '@emotion/styled';
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { createUUID } from '@shared/constants/Keys';
import { color } from '@shared/constants/Styles';
import { ComponentProps } from 'react';
import { IconName } from '../images/IconMap';
import Icons from '../images/Icons';

export interface ITextInputWithAdornmentProps extends ComponentProps<typeof OutlinedInput> {
    icon?: IconName;
    iconSize?: number;
    inputLabel: string;
    actionLabel: string;
    onClick?: () => void;
}

export default function TextInputWithAdornment({
    icon = 'duplicate',
    iconSize = 32,
    onClick,
    inputLabel,
    actionLabel,
    value,
    readOnly,
}: ITextInputWithAdornmentProps) {
    const id = createUUID();
    return (
        <>
            <FormControl sx={{ marginTop: '16px', marginBottom: '8px' }} fullWidth variant="outlined">
                <InputLabel htmlFor={id}>{inputLabel}</InputLabel>
                <OutlinedInput
                    id={id}
                    type="text"
                    value={value}
                    onClick={onClick}
                    readOnly={readOnly}
                    endAdornment={
                        <StyledInputAdornment position="end">
                            <Button aria-label={actionLabel} onClick={onClick}>
                                <Icons name={icon} size={iconSize} />
                            </Button>
                        </StyledInputAdornment>
                    }
                    label={inputLabel}
                />
            </FormControl>
        </>
    );
}

const Button = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
`;

const StyledInputAdornment = styled(InputAdornment)`
    background-color: ${color.border};
    color: ${color.primary_dark};
    padding: 28px 14px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: 1px solid ${color.border};
`;
